import { apiFetch, isErrorResult } from "../../../../app/apiClient.js";
import { currentTable } from "../../../../app/viewManager.js";
import { updateFilterOptions } from "../utils/filterManager.js";
import { validateData, getContent, removeStaleRow, deleteRecord } from "./tableManager.js";
import { toast } from "../../../layout/app-toast/utils/toastManager.js";

function sortByName() { currentTable.setSort("name", "asc"); }

function formatRole(rolePermission) {
    return {
        id: rolePermission.id,
        name: rolePermission.name,
        permissionId: rolePermission.permissions.map(p => p.id).join("; ") + ";",
        permissionName: rolePermission.permissions.map(p => p.name).join("; ") + ";"
    };
}

export async function loadRolePermissions() {
    const rolePermissions = await apiFetch("rolePermission");
    currentTable.options.placeholder = "Keine Daten vorhanden";
    if (!Array.isArray(rolePermissions)) { currentTable.replaceData([]); return; }

    currentTable.setData(rolePermissions.map(formatRole));
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
}

async function collectData() {
    const content = getContent();
    if (!content) return null;

    return {
        RoleName:      content.querySelector("#inputRoleName")?.getValue?.()      ?? "",
        PermissionIds: content.querySelector("#dropdownPermission")?.getValue?.() ?? [],
    };
}

export async function createRole() {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const newRole = await apiFetch(`rolePermission`, "POST", {
        RoleName: collectedData.RoleName,
        PermissionIds: collectedData.PermissionIds
    });
    if (isErrorResult(newRole)) return newRole ? true : undefined;

    await currentTable.addRow(formatRole(newRole), true);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Rolle erfolgreich hinzugefügt!", "success");
    return newRole;
}

export async function updateRole(roleId) {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const updatedRole = await apiFetch(`rolePermission/${roleId}`, "PATCH", {
        RoleName: collectedData.RoleName,
        PermissionIds: collectedData.PermissionIds
    });
    if (removeStaleRow(updatedRole, roleId)) return;
    if (isErrorResult(updatedRole)) return updatedRole ? true : undefined;

    await currentTable.updateOrAddData([formatRole(updatedRole)]);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Rolle erfolgreich aktualisiert!", "success");
    return updatedRole;
}

export const deleteRole = (roleId) => deleteRecord("rolePermission", roleId, "Rolle erfolgreich gelöscht!");